import PropTypes from 'prop-types'
import React from 'react'

const VisibilityIcon = ({
   className,
   color,
   width,
   height,
   strokeWidth
}) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24">
      <g
         className={className}
         strokeLinecap="round"
         strokeLinejoin="round"
         strokeWidth={strokeWidth}
         fill={color}
         stroke={color}>
         <path
            fill="none"
            stroke={color}
            strokeMiterlimit="10"
            d="M2,12c0,0,4-7,10-7 c6,0,10,7,10,7s-4,7-10,7C6,19,2,12,2,12z"
         />
         <circle
            fill="none"
            strokeMiterlimit="10"
            cx="12"
            cy="12"
            r="3"
         />
      </g>
   </svg>
)

VisibilityIcon.propTypes = {
   className: PropTypes.string,
   color: PropTypes.string,
   height: PropTypes.string,
   strokeWidth: PropTypes.string,
   width: PropTypes.string
}

VisibilityIcon.defaultProps = {
   className: undefined,
   color: '#444',
   height: '24px',
   strokeWidth: '1',
   width: '24px'
}

export default React.memo(VisibilityIcon)
